/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-expand-xl': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M11.971.5l.09.004 4.524.562.09.02a.5.5 0 0 1 .348.476V6l-.008.09a.5.5 0 0 1-.992-.09V2.828L9.755 9.007l6.267 6.201.001-3.208a.5.5 0 0 1 .992-.09l.008.09v4.438a.5.5 0 0 1-.347.476l-.091.02-4.523.562a.5.5 0 0 1-.212-.973l.088-.02 3.543-.438a.497.497 0 0 1-.01-.007L15.4 16 9.043 9.71l-6.455 6.363 3.474.432.088.019a.5.5 0 0 1-.212.973l-4.523-.562-.09-.02a.5.5 0 0 1-.348-.476V12l.008-.09a.5.5 0 0 1 .992.09v3.269l6.355-6.264-6.315-6.248V6a.5.5 0 0 1-.992.09L1.017 6V1.562a.5.5 0 0 1 .347-.476l.09-.02L5.939.504a.5.5 0 0 1 .212.973l-.088.02-3.46.433 6.442 6.373 6.37-6.279a.5.5 0 0 1 .112-.083l-3.588-.445-.088-.019a.5.5 0 0 1 .212-.973z" _fill="#0D204A" fill-rule="evenodd"/>'
  }
})
